import { render, staticRenderFns } from "./CreatePresetDialog.vue?vue&type=template&id=bda1b170&scoped=true"
import script from "./CreatePresetDialog.vue?vue&type=script&lang=js"
export * from "./CreatePresetDialog.vue?vue&type=script&lang=js"
import style0 from "./CreatePresetDialog.vue?vue&type=style&index=0&id=bda1b170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda1b170",
  null
  
)

export default component.exports